<template>
    <div class='container_box' v-if="$store.state.bAutorty">
        <div class="content_box">
            <div class="title">信息填写弹窗</div>
            <div class="input_group">
                <input type="text" v-model="uphone" placeholder="请填写您的手机号" :maxlength="11">
            </div>
            <div class="input_group_code">
                <div class="code_input">
                    <input type="text" v-model="uCode" placeholder="验证码" :maxlength="4">
                </div>
                <div class="code_btn" @click="codeNum">
                    {{codeName}}
                </div>
            </div>
            <div class="btn flc" @click="accept">确认登录</div>
        </div>
    </div>
</template>

<script>
    import oAuthority from '@/js/authority/index.js'
    export default {
        name: "index",
        data() {
            return {
                uCode: '',// 验证码
                uphone: '',// 用户电话
                codeName:'获取验证码',
            }
        },
        methods:{
            /*
            * 倒计时
            * */
            codeNum(){
                let _that = this
                if( _that.codeName != '获取验证码'){
                    _that.$toast('请勿重复获取验证码')
                    return false
                }
                const reg = /^[1][3,4,5,7,8,6][0-9]{9}$/;
                if((!reg.test(_that.uphone))){
                    _that.$toast('请输入正确的手机号')
                    return false
                }
                oAuthority.commSmsSend({phone: _that.uphone}).then(res=>{
                    console.log(res)
                    let num = 60;
                    num = num - 1;
                    _that.codeName = num + 's';
                    let setInTime = null;
                    setInTime = setInterval(()=>{
                        num = num - 1;
                        _that.codeName = num + 's';
                        if(num == 0 ){
                            _that.codeName = '获取验证码';
                            clearInterval(setInTime);
                        }
                    },1000)
                })
            },
            // 点击绑定潜客
            accept() {
                const reg = /^[1][3,4,5,7,8,6][0-9]{9}$/;
                if ((!reg.test(this.uphone))) {
                    this.$toast('请输入正确的手机号')
                } else if (this.uCode == '') {
                    this.$toast('请输入验证码')
                } else {
                    this.$store.commit("loadSwitch", true);
                    oAuthority.accessBind({phone: this.uphone,code: this.uCode}).then(res=>{
                        this.$store.commit('loadAutorty',false);
                        this.$store.commit("loadSwitch", false);
                        this.$emit("update:BinfoToast",false);
                        this.$emit("changeLogin",res);
                    }).catch(err=>{
                        console.log(err,'err')
                        this.$store.commit("loadSwitch", false);
                        this.uCode = '';
                        this.uphone = '';
                    })
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
    .flc {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .positionc {
        left: 50%;
        transform: translate(-50%);
    }
    .container_box {
        z-index: 1000;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        position: absolute;
        background: rgba(0, 0, 0, 0.6);
        .colseImg {
            width: 48px;
            height: 48px;
            position: absolute;
            top: 930px;
            img {
                width: 48px;
                height: 48px;
            }
        }
        .content_box {
            padding: 0 32px 64px;
            box-sizing: border-box;
            width: 476px;
            height: 546px;
            background: #FFFFFF;
            border-radius: 16px;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            top: 24.6%;
            .title {
                text-align: center;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #2B2B2B;
                margin-top: 32px;
            }
            .input_group_code{
                margin-top: 26px;
                display: flex;
                justify-content: space-between;
                .code_input{
                    width: 55%;
                }
                .code_btn{
                    width: 40%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #318544;
                    border-radius: 8px;
                    color: #fff;
                    font-size: 28px;
                }
                input {
                    padding: 22px 24px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #585757;
                    width: 100%;
                    background: #F7F7F7;
                    border-radius: 8px;
                    &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                        color: #A5A5A5;
                    }
                    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                        color: #A5A5A5;
                    }
                    &::-moz-placeholder { /* Mozilla Firefox 19+ */
                        color: #A5A5A5;
                    }
                    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                        color: #A5A5A5;
                    }
                }
            }
            .input_group {
                margin-top: 26px;
                input {
                    margin-top: 24px;
                    padding: 22px 24px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #585757;
                    width: 100%;
                    background: #F7F7F7;
                    border-radius: 8px;
                    &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                        color: #A5A5A5;
                    }
                    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                        color: #A5A5A5;
                    }
                    &::-moz-placeholder { /* Mozilla Firefox 19+ */
                        color: #A5A5A5;
                    }
                    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                        color: #A5A5A5;
                    }
                }
            }
            .btn {
                width: 304px;
                height: 88px;
                background: #318544;
                box-shadow: 0px 4px 8px 0px rgba(49, 133, 68, 0.27);
                border-radius: 44px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                margin: 80px auto 0;
            }
        }
    }
</style>
